<li
	*ngIf="appearancePreferenceService.scaleLayoutEnabled$ | async"
	@appearancePreferenceVisibility
	class="nav-item d-flex align-items-center h-100"
	ngbDropdown
	display="dynamic"
	placement="auto"
	container="body"
	(openChange)="onOpenChange($event)"
	#zoomLayoutDropdown="ngbDropdown"
>
	<a
		class="nav-link align-middle"
		[class.scale-menu-icon]="isOpenMenuPragmatically"
		role="button"
		ngbDropdownToggle
		aria-label="Scale layout"
		title="Scale layout"
	>
		<span class="align-middle scale-icon">
			<ng-fa-icon
				class="d-inline-flex"
				icon="text-size"
			></ng-fa-icon>
		</span>
	</a>

	<!-- Dropdown block -->
	<div
		ngbDropdownMenu
		*ngIf="deviceDetectionService.getDeviceZoom() === 1 && deviceDetectionService.getDevice() !== EnumDevice.Mobile"
		class="dropdown-menu dropdown-menu-end scale-main-layout p-3 no-selection"
	>
		<!-- Dropdown header -->
		<div
			class="scale-layout-header"
			*ngIf="browser !== browserDetectionService.EnumBrowser.MozillaFirefox; else firefoxLayout"
		>
			<div>
				Scale Layout
				<ng-info-popover
					title="Scale Layout"
					message="The scale layout is a accessibility feature provided to improve the overall work experience in different screen sizes. It can be used to scale the layout and its content to a custom size. By doing so, the elements can either be scaled larger for easier readability or smaller for a better workflow on small screens. The auto mode, which is the recommended setting, will scale the layout automatically based on the screen and display size."
				></ng-info-popover>
			</div>

			<div
				class="text-muted"
				role="button"
				tabindex="0"
				aria-label="Reset layout scale"
				(click)="scaleLayoutService.resetScale()"
				(keydown.enter)="scaleLayoutService.resetScale()"
				(keydown.space)="scaleLayoutService.resetScale(); $event.preventDefault()"
			>
				<ng-fa-icon
					class="d-inline-flex"
					icon="arrow-rotate-right"
					size="sm"
				></ng-fa-icon>
				Reset
			</div>
		</div>

		<!-- Firefox layout -->
		<ng-template #firefoxLayout>
			<div class="firefox-layout text-lg text-center text-muted">
				<span class="pe-1">
					<ng-fa-icon
						class="d-inline-flex"
						icon="firefox"
						size="sm"
					></ng-fa-icon>
				</span>
				<span class="text-layout-weight">Firefox</span>
			</div>
		</ng-template>

		<!-- Dropdown block -->
		<div
			class="pt-2 slidecontainer"
			*ngIf="browser !== browserDetectionService.EnumBrowser.MozillaFirefox"
		>
			<div class="scale-layout-label">
				<span class="spacing-layout"></span>
				<span>{{ scaleValuePercent }}%</span>
				<span class="spacing-layout"></span>
			</div>
			<input
				type="range"
				class="w-100"
				aria-label="Layout scale percentage"
				[(ngModel)]="scaleValuePercent"
				[min]="scaleLayoutService.getMinScale() * 100"
				[max]="scaleLayoutService.getMaxScale() * 100"
				(change)="scaleLayoutService.setScale(scaleValuePercent / 100)"
			/>
		</div>

		<!-- Dropdown info -->
		<div class="d-flex justify-content-center align-items-center text-justify">
			<span
				class="text-sm text-muted"
				*ngIf="browser === browserDetectionService.EnumBrowser.MozillaFirefox; else notFirefox"
			>
				The scaling functionality is not supported by Firefox, we recommend using the
				<a
					[href]="getBrowserLink()"
					target="_blank"
				>
					content sizing
				</a>
				through the Firefox browser. If you are on a tablet, we would recommend using another browser, as
				content sizing will not be available.
			</span>
			<ng-template #notFirefox>
				<span
					class="text-sm text-muted"
					*ngIf="deviceType === EnumDevice.Tablet; else desktopDevice"
				>
					Using a low scaling makes the pages more user-friendly on tables. Please note: it can cause problems
					with parts of the website.
				</span>
				<ng-template #desktopDevice>
					<span class="text-sm text-muted">
						Scaling can cause problems with the website. We recommend the content sizing through the
						<a
							[href]="getBrowserLink()"
							target="_blank"
						>
							{{ browserDetectionService.getBrowserName() }}
						</a>
						browser.
					</span>
				</ng-template>
			</ng-template>
		</div>
	</div>

	<!-- Browser Zoom is already using -->
	<div
		ngbDropdownMenu
		*ngIf="deviceDetectionService.getDeviceZoom() !== 1"
		class="dropdown-menu dropdown-menu-end scale-main-layout p-3 device-zoom-info"
	>
		<div class="firefox-layout text-lg text-center mb-2">
			<span class="pe-1">
				<ng-fa-icon
					class="d-inline-flex"
					icon="chrome"
					iconStyle="brands"
					size="sm"
				></ng-fa-icon>
			</span>
			<span class="text-layout-weight">Active Browser Zoom</span>
		</div>
		<div class="d-flex justify-content-center align-items-center text-justify text-sm">
			<span>
				The layout scaling and the browser zoom are similar functionalities and can not be use together. If
				available the browser zoom is the recommended approach. The scaling is deactivated as long as the
				browser zoom is active and not at the default of 100%.
			</span>
		</div>
	</div>

	<!-- Mobile View -->
	<div
		ngbDropdownMenu
		*ngIf="deviceDetectionService.getDevice() === EnumDevice.Mobile"
		class="dropdown-menu dropdown-menu-end scale-main-layout p-3 device-zoom-info"
	>
		<div class="firefox-layout text-lg text-center mb-2">
			<span class="pe-1">
				<ng-fa-icon
					class="d-inline-flex"
					icon="mobile-screen-button"
					size="sm"
				></ng-fa-icon>
			</span>
			<span class="text-layout-weight">Mobile Device</span>
		</div>
		<div class="d-flex justify-content-center align-items-center text-justify text-sm">
			<span>
				The layout scaling is an accessibility functionality which is not supported on mobile devices. It
				improves the work experience on tablets and desktops. Please note that the web application was not
				designed for mobile, we recommend using a tablet or a desktop computer.
			</span>
		</div>
	</div>
</li>
